import React, { Component } from "react";
import { Row, Col } from "antd";
import { RightOutlined } from "@ant-design/icons";
import "styles/Footer.scss";
import { COL_1_LINKS, COL_2_LINKS, SOCIAL_LINKS } from "utils/footerLinks";
import BackTopArrowIcon from "assets/Back-Top-Arrow.svg";

export default class Footer extends Component {
  scrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  render() {
    return (
      <div className="footer-container">
        <div onClick={this.scrollToTop} className="desktop-only ">
          <div className="desktop-back-to-top">
            <div className="back-to-top vertical-rotate ">
              <div style={{ marginRight: 20 }}>Back to top</div>
              <RightOutlined />
            </div>
          </div>
        </div>
        <div className="footer-green-line desktop-only" />
        <div className="footer-content-container">
          <div onClick={this.scrollToTop} className="mobile-only footer-col">
            <div className="flex-align-items-center">
              <img src={BackTopArrowIcon} alt="Back to top arrow" />
              <div className="back-to-top">Back to top</div>
            </div>
          </div>
          <Row>
            <Col className="footer-col" lg={24} xl={6}>
              <h1 className="footer-link-title">Quick links</h1>
              {COL_1_LINKS.map((link) => (
                <a
                  key={link.name}
                  className="footer-link"
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.name}
                </a>
              ))}
            </Col>
            <Col className="footer-col" lg={24} xl={6}>
              {COL_2_LINKS.map((link) => (
                <a
                  key={link.name}
                  className="footer-link"
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.name}
                </a>
              ))}
            </Col>
            <Col className="footer-col" lg={24} xl={6} />
            <Col className="footer-col" lg={24} xl={6}>
              <div className="footer-social-container">
                <h2 className="footer-social-title">Follow Us</h2>
                <div className="footer-social-icons-container">
                  {SOCIAL_LINKS.map((link) => (
                    <a
                      aria-label={link.name}
                      key={link.name}
                      className="footer-social-icon"
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className={link.icon} />
                    </a>
                  ))}
                </div>
              </div>
            </Col>

            <Col className="footer-col" span={24}>
              <p className="footer-copyright">
                &copy; {new Date().getFullYear()} Universities Admissions Centre
                (NSW & ACT) Pty Ltd ACN 070 055 935 ABN 19 070 055 935
              </p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
